import { useEffect, useState } from "react";
import { TextArea } from "../../ui/inputs/TextArea";
import { getOwnerData, postOwnerData } from "../../../api/ownerData";
import { showToastError, showToastSuccess } from "../../../services/toast";

const ClientText = () => {
  const [informations, setInformations] = useState("");

  const handleChangeInformations = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setInformations(e.target.value);
  };

  const handlePostInformations = () => {
    postOwnerData({ newsCustomerSentence: informations })
      .then(() => {
        showToastSuccess(
          "Informations pour les clients enregistrées avec succès",
        );
      })
      .catch(() => {
        showToastError(
          "Erreur lors de l'enregistrement des informations pour les clients",
        );
      });
  };

  useEffect(() => {
    getOwnerData()
      .then((res) => {
        setInformations(res.data || "");
      })
      .catch((err) => {
        showToastError(err.response.data.message);
      });
  }, []);

  return (
    <div className="flex flex-col gap-5">
      {/* En-tête */}
      <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
        <p className="text-[11px] font-bold tracking-wider text-slate-400 uppercase">
          Espace client
        </p>
        <h2 className="mt-1 text-xl font-bold tracking-tight text-slate-900">
          Informations clients
        </h2>
        <p className="mt-1 font-Nunito text-sm text-slate-500">
          Ce texte est affiché sur la page d'accueil de l'espace client.
          Utilisez-le pour partager une information importante ou un message de
          bienvenue.
        </p>
      </div>

      {/* Formulaire */}
      <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <div className="p-5 space-y-5">
          <TextArea
            label="Informations pour les clients"
            name="informations"
            value={informations}
            onChange={handleChangeInformations}
          />

          <div className="flex justify-end border-t border-slate-100 pt-4">
            <button
              type="button"
              onClick={handlePostInformations}
              className="inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl bg-light-red px-5 py-2.5 font-Nunito text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:opacity-90 hover:shadow-md hover:shadow-light-red/20 focus-visible:ring-2 focus-visible:ring-light-red/40 focus-visible:outline-none"
            >
              <svg aria-hidden="true" className="size-4" fill="none" stroke="currentColor" strokeWidth={2.2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              Enregistrer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientText;
